<script>
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { actionStore } from "@common/actionStore";
import { SkeletonComponent } from "@syncfusion/ej2-vue-notifications";
import { configStore } from "@common/configStore";
import { recordStore } from "@common/recordStore";

const runOnceActions = {
    // Put actions in only
};
let generateIdFnc = function (type, templateIndex = 0) {
    return `activity_step_panel_${this.cId}_${type}_${templateIndex}`;
};
let localComponents = {};

let isExistingTemplate = (itemTemplate) => {
    let output = false;
    for (let templateId in localComponents) {
        if (localComponents[templateId] === itemTemplate) {
            output = templateId;
            break;
        }
    }
    return output;
};

let validTemplate = (template) => {
    let output = true;
    if (!template) return output;
    let interpolationItems = template.match(/{{(.*)}}/);
    if (interpolationItems) {
        interpolationItems.shift();
        for (let interpolationString of interpolationItems) {
            if (interpolationString.indexOf('.') === -1
                && interpolationString !== 'record'
                && interpolationString.indexOf('record["') === -1
                && interpolationString.indexOf("record['") === -1
            ) {
                // check for v-for
                let vforRgx = 'v-for=[\'"]\\(?' + interpolationString;
                if (!template.match(vforRgx, 'g')) {
                    output = false;
                }
                break;
            }
        }
    }
    return output;
};

let createComp = function (template, type, templateIndex) {
    let tmpTemplate = `<div>${template}</div>`;
    // Don't create new component when one with exact same template already exists
    // (Note: This is different from preventing this template rendering twice)
    let existing = isExistingTemplate(tmpTemplate);
    if (existing) return existing;
    let iTemplateCmpId = generateIdFnc.call(this, type, templateIndex);
    if (localComponents[iTemplateCmpId]) return iTemplateCmpId;
    if (!validTemplate(template)) tmpTemplate = `<div>(Invalid Template)</div>`;
    let component = this;
    // let recordStore = this.recordStore;
    vueApp.component(iTemplateCmpId, {
        template: tmpTemplate,
        data() {
            return {
                templateData: {}, // A place to put custom, local, template specific settings
                // component: component,
            };
        },
        props: {
            hovered: {
                type: Boolean,
                default: false
            },
            targeted: {
                type: Boolean,
                default: false
            },
            record: {
                type: Object,
                default() {
                    return {};
                }
            },
            itemRecords: {
                type: Array,
                default() {
                    return [];
                }
            },
            index: {}
        },
        computed: {
            moment() {
                return library.getMomentObj();
            },
            actionStore() {
                return actionStore;
            },
            records() {
                return recordStore().records;
            },
            // These will be available fields to use in the itemList headerTemplate
            // example: records.vol[volId].VOL_FIRST_NAME
            // example: records.user.CLIENT_NAME
            // example: records.opp[oppId]['CA#Application_Questions/Region_0']
            volId() {
                return component.contextVolId;
            },
            user() {
                return component.user;
            },
            oppId() {
                return component.contextOppId || component.oppId;
            },
            orgId() {
                return component.contextOrgId || component.orgId;
            },
            aeId() {
                return component.contextAeId || component.aeId;
            },
            entryPointId() {
                return component.contextEntryPointId || component.entryPointId;
            },
            affId() {
                return component.contextAffId || component.affId;
            },
            schId() {
                return component.contextSchId || component.schId;
            },
            lbeId() {
                return component.contextLbeId || component.lbeId;
            }
        },
        methods: {
            trimHTML(str) {
                return library.trimHTML(str);
            },
            dateDetails(dateStr, formatStr) {
                let momentDate = library.getMoment(dateStr, formatStr);
                return {
                    D: momentDate.format('D'),
                    MMM: momentDate.format('MMM'),
                    dddd: momentDate.format('dddd'),
                };
            },
            toggleDelay(time, property) {
                this.templateData[property] = !this.templateData[property];
                setTimeout(() => {
                    this.templateData[property] = !this.templateData[property];
                }, parseInt(time, 10));
            }
        }
    });
    // TODO also destroy these components when the itemList is destroyed
    localComponents[iTemplateCmpId] = tmpTemplate;
    return iTemplateCmpId;
};

const locals = {
    formatToUI(step, relatedRecords, _this) {
        let userStore = _this.userStore;
        let getStepRecords = (step) => {
            // Returns the correct records for each activity (step)
            let recordMatcher = (type) => {
                if (!relatedRecords || typeof relatedRecords[type] !== 'object') return false;
                let records = library.cloneObj(relatedRecords[type]);
                if (!Array.isArray(records)) records = Object.values(records);
                return records.find((record) => record && record.AFFILIATION_ID === step.AFFILIATION_ID);
            };
            return {
                aff: recordMatcher('aff'),
                lbe: recordMatcher('lbe'),
                waiver: recordMatcher('waiver'),
                training: recordMatcher('training'),
                shift: recordMatcher('sch'),
            };
        };
        // Mapping/Formatting Functions
        let setLogicRecords = (serverLogic, step) => {
            let output = [];
            let records = step.relatedRecords;
            if (!library.isJson(serverLogic)) return output;
            let logicObj = JSON.parse(serverLogic);
            let logicRule = logicObj['[FilterEditor::FiltersColumns]'];
            if (Array.isArray(logicRule)) {
                for (let i in logicRule) {
                    if (i === 'length') continue;
                    if (typeof logicRule[i].CLAUSE_TITLE !== 'string') continue;
                    let logicField = logicRule[i].CLAUSE_TITLE.toLowerCase();
                    output[i] = { criteriaRecord: 'dynamically' };
                    // Set the perspective
                    let logicPsp = logicRule[i].FLT_SELECT_FIELD_PERSPECTIVE_ABBREV;
                    if (logicPsp === 'lbe') {
                        if (logicRule[i].LBE_TYPE === 5) logicPsp = 'waiver'; // NOSONAR
                        if (logicRule[i].LBE_TYPE === 6) logicPsp = 'training'; // NOSONAR
                    }
                    let assignmentSubRecord = logicRule[i].FLT_CLAUSE_PSP_OPTION; // Sub-record is related orgs (eg: tier 500) ie: orgKind
                    // Check for is assignment record
                    if (logicField === 'aff:assignment status') {
                        output[i].recordId = relatedRecords.ASSIGNMENT_ID;
                    }
                    // Check for a selected "Sub Record" from the assignment
                    else if (assignmentSubRecord && assignmentSubRecord !== 2) {
                        if (assignmentSubRecord === 1) output[i].recordId = relatedRecords.ASSIGNMENT_ID;
                        else if (assignmentSubRecord === 9999) output[i].recordId = relatedRecords.DETAIL_RECORD_ID; // NOSONAR
                        else if (logicField.indexOf('aff') === 0) output[i].recordId = relatedRecords?.ASSIGNMENT?.LINKED_AFFILIATIONS?.[assignmentSubRecord];
                        else output[i].recordId = relatedRecords?.ASSIGNMENT?.LINKED_RECORDS?.[assignmentSubRecord];
                    }
                    // Otherwise link using the perspective
                    else if (logicPsp === 'aff') output[i].recordId = records.aff && records.aff.AFFILIATION_ID;
                    else if (logicPsp === 'lbe') output[i].recordId = records.lbe && records.lbe.LOG_BOOK_ENTRY_ID;
                    else if (logicPsp === 'waiver') output[i].recordId = records.waiver && records.waiver.LOG_BOOK_ENTRY_ID;
                    else if (logicPsp === 'training') output[i].recordId = records.training && records.training.LOG_BOOK_ENTRY_ID;
                    else if (logicPsp === 'sch') {
                        // output[i].recordId = records.shift && records.shift.SCHEDULE_SLOT_ID;
                        output[i].criteriaRecord = 'object2';
                    }
                    else if (logicPsp === 'client') {
                        output[i].criteriaRecord = 'component.ecUserProperty';
                    }
                }
            }
            return output;
        };
        let mapTemplates = (tItem, step, hideWhenComplete, hideWhenDisabled) => {
            tItem.template = tItem.TEXT;
            tItem.include = tItem.IS_DEFAULT !== 0 || !tItem.LOGIC;
            if (tItem.LOGIC) {
                let logicRecords = setLogicRecords(tItem.LOGIC, step);
                let criteria = library.parseLogicToFront(tItem.LOGIC, logicRecords);
                tItem.includeWhen = [{ criteria, resultType: 'returnCriteria' }];
            }
            tItem.hideWhenDisabled = hideWhenDisabled;
            tItem.hideWhenComplete = hideWhenComplete;
            return tItem;
        };
        let parseActionLogic = (action, step, logicType) => {
            if (action[logicType]) {
                let logicRecords = setLogicRecords(action[logicType], step);
                let criteria = library.parseLogicToFront(action[logicType], logicRecords);
                return [{ criteria, resultType: 'returnCriteria' }];
            }
            return false;
        };
        let mapActions = (action, step, hideWhenComplete, hideWhenDisabled) => {
            let tAction = library.cloneObj(action);
            tAction.label = tAction.TEXT;
            // Convert legacy config to standard
            // TODO: Remove this code after all configurations have been updated https://samaritan.atlassian.net/browse/DEVD-1202
            if (tAction.ACTION
                && typeof tAction.ACTION === 'object'
                && !Array.isArray(tAction.ACTION)
                && tAction.ACTION.params
            ) {
                let chainedActions = [];
                if (tAction.ACTION.params.actionChaining) {
                    chainedActions = library.cloneObj(tAction.ACTION.params.actionChaining);
                    delete tAction.ACTION.params.actionChaining;
                }
                let formattedVal = [tAction.ACTION];
                formattedVal = formattedVal.concat(chainedActions);
                tAction.action = formattedVal;
            } else tAction.action = tAction.ACTION;
            tAction.actionIcon = tAction.ACTION_ICON;
            tAction.include = !!tAction.IS_DEFAULT;
            if (tAction.CSS_CLASSES) tAction.cssClasses = tAction.CSS_CLASSES;

            tAction.includeWhen = parseActionLogic(tAction, step, 'LOGIC');
            tAction.disableWhen = parseActionLogic(tAction, step, 'DISABLE_LOGIC');

            tAction.hideWhenDisabled = hideWhenDisabled;
            tAction.hideWhenComplete = hideWhenComplete;
            return tAction;
        };
        let processStepLogic = (step) => {
            let v1 = 1; // By Default
            let v2 = 2; // Use Logic Editor
            let v3 = 3; // Use Volunteer's Affiliation Status
            // Set include property
            let setStepState = (stepKey) => {
                // stepKey is one of: include, enable, complete
                let partialKey = 'AE_' + stepKey.toUpperCase() + 'D'; // eg: AE_INCLUDED, AE_ENABLED, AE_COMPLETED
                let sOption = step[partialKey + '_BY_DEFAULT']; // eg: 1, 2, 3
                let affStatusKey = partialKey + '_AFF_STATUS_ID'; // eg: AE_INCLUDED_AFF_STATUS_ID
                let logicKey = partialKey + '_LOGIC_FILTER_ID'; // eg: AE_INCLUDED_LOGIC_FILTER_ID
                let criteria;
                if (!sOption || sOption === v1) {
                    criteria = {
                        rules: [{
                            field: partialKey + '_BY_DEFAULT',
                            operator: 'equal',
                            type: 'numeric',
                            value: v1,
                            criteriaRecord: 'object1' // previous step completed
                        }],
                        condition: 'and'
                    };
                }
                else if (sOption === v2 && step[logicKey]) {
                    let logicRecords = setLogicRecords(step[logicKey], step);
                    criteria = library.parseLogicToFront(step[logicKey], logicRecords);
                }
                else if (sOption === v3) {
                    let stepRecords = step.relatedRecords;
                    // Map selected status option from activity profile to logic criteria
                    if (stepRecords.aff) {
                        criteria = {
                            rules: [{
                                label: 'AFF:Status',
                                field: 'AFF_STATUS_ID',
                                operator: 'equal',
                                type: 'numeric',
                                value: step[affStatusKey],
                                psp: 'aff',
                                criteriaRecord: 'dynamically',
                                recordId: stepRecords.aff.AFFILIATION_ID
                            }],
                            condition: 'and'
                        };
                    }
                }
                if (criteria) step[stepKey + 'When'] = [{ criteria, resultType: 'returnCriteria' }];
            };
            setStepState('include');
            setStepState('enable');
            setStepState('complete');
            let setOnChangeActions = () => {
                // if (!step['AE_ENABLED_SET'] || workflowConfig?.WORKFLOW_DISABLE_AUTO_STATUS_UPDATES) return; // Only care if we have the setting
                const stepRecords = step.relatedRecords;
                const currStatus = stepRecords?.aff?.AFF_STATUS_ID;
                const newStatus = parseInt(step.AE_ENABLED_SET_AFF_STATUS_ID, 10) > 0 && step.AE_ENABLED_SET_AFF_STATUS_ID;
                const newReason = parseInt(step.AE_ENABLED_SET_AFF_REASON_ID, 10) > 0 && step.AE_ENABLED_SET_AFF_REASON_ID;
                const newDate = typeof step.AE_ENABLED_SET_AFF_START_DATE === 'string' && step.AE_ENABLED_SET_AFF_START_DATE ? step.AE_ENABLED_SET_AFF_START_DATE : false;

                if (!newStatus || currStatus !== 1) return;

                let changeField;
                let criteriaObj;

                // TODO pickup here and start working
                switch (+step.AE_ENABLED_SET) {
                    case 1: // Previous step is complete
                        changeField = 'complete';
                        criteriaObj = 'object3';
                        break;
                    case 2: // All previous steps are complete
                        changeField = 'previousStepsComplete';
                        criteriaObj = 'object1';
                        break;
                    // additional cases are coming soon. FT-531
                    default:
                        changeField = false;
                        criteriaObj = false;
                }
                // Map selected status option from activity profile to logic criteria
                const onChangeCriteria = {
                    rules: [{ // This rule is intentionally duplicating the logic in line above "stepRecords.aff.AFF_STATUS_ID..."
                        label: 'AFF:Status ID',
                        field: 'AFF_STATUS_ID',
                        operator: 'equal',
                        type: 'numeric',
                        value: 1,
                        psp: 'aff',
                        criteriaRecord: 'dynamically',
                        recordId: stepRecords.aff.AFFILIATION_ID
                    }, {
                        field: changeField,
                        operator: 'equal',
                        type: 'boolean',
                        value: true,
                        criteriaRecord: criteriaObj // previous step completed
                    }],
                    condition: 'and'
                };
                // Put the complete onChangeActions configuration into the step configuration
                const onChangeActions = [
                    {
                        logic: [{
                            criteria: onChangeCriteria,
                            resultType: 'returnCriteria',
                        }],
                        actions: [
                            {
                                action: 'updateAffiliation',
                                params: {
                                    affID: stepRecords.aff.AFFILIATION_ID,
                                    AFF_STATUS: newStatus,
                                    AFF_REASON: newReason, // It might be false
                                    AFF_START_DATE: newDate,
                                    disableResponseMessage: true
                                }
                            }
                        ],
                        executeIfLogicResult: true,
                        runOnce: true
                    }
                ];
                step.onChangeActions = onChangeActions;
            };
            setOnChangeActions();
        };
        let processExpiration = (step) => {
            // return if status ID isn't 3 (expiring)
            let complianceStatus = step?.relatedRecords?.aff?.AFF_COMPLIANCE_STATUS_ID;
            let affStatus = step?.relatedRecords?.aff?.AFF_STATUS_ID;
            if (complianceStatus === 3 || (complianceStatus === 5 && affStatus !== 4)) step.cssClasses += ' item-expiring';
            if (complianceStatus !== 3) return;
            const EXPIRATION_DATE = step?.relatedRecords?.aff?.AFF_EXPIRATION_DATE || false;
            const EXPIRATION_MESSAGE = 'This task is about to expire, click the button to begin renewal.';
            const expirationTemplate = {
                template: `<div class="activity-expiration expiration-flag">
                                <i class="fa-solid fa-triangle-exclamation"></i>
                                <div class="expiration-text">
                                    <strong style="display: flex">
                                        Expiring Soon
                                        <span v-if="${EXPIRATION_DATE}"
                                              style="font-weight: normal; color: #4c4c4c; margin-left: 6px"
                                        >- ${EXPIRATION_DATE}</span>
                                    </strong>
                                    <span>
                                        ${EXPIRATION_MESSAGE}
                                    </span>
                                </div>
                                <button type="button"
                                        class="coordinator-action-button"
                                        title="Renew"
                                        @click="actionStore.renewActivity(
                                                    {
                                                        currentAffId: record.AFFILIATION_ID,
                                                        volId: record.VOLUNTEER_ID,
                                                        activityId: record.ACTIVITY_ENTITY_ID,
                                                        repeatOrgId: '',
                                                        fields: [
                                                            { field: 'AFF_STATUS', value: 3},
                                                            { field: 'AFF_REASON', value: 503},
                                                            { field: 'AFF_COMPLIANCE_STATUS', value: 5},
                                                        ]
                                                    })"
                                ><span>Renew</span>
                                </button>
                           </div>`,
                cssClasses: 'renew-message'
            };

            step.descriptions.unshift(expirationTemplate);
        };
        if (typeof step !== 'object') return {};
        step.relatedRecords = getStepRecords(step);
        step.aeId = step.ACTIVITY_ENTITY_ID;
        step.volId = _this.contextVolId || step.VOLUNTEER_ID;
        if (!library.objIsEmpty(step.relatedRecords)) {
            for (let psp in step.relatedRecords) {
                if (typeof step.relatedRecords[psp]?.ID !== 'undefined') step[psp + 'Id'] = step.relatedRecords[psp].ID;
            }
        }
        if (typeof step.AE_CSSCLASSES !== 'undefined') step.cssClasses = step.AE_CSSCLASSES;
        if (step.AE_IS_COMPLIANCE) {
            const complianceClass = 'compliance-status-' + step?.relatedRecords?.aff?.AFF_COMPLIANCE_STATUS_ID;
            step.cssClasses = step.cssClasses === 'undefined' ? complianceClass : step.cssClasses + ' ' + complianceClass;
        }
        // Hide for coordinator users that cannot see the activity
        let isVisible = !userStore?.coordinator?.availableActivities
            || !!userStore.coordinator.availableActivities.find((ca) => step.ACTIVITY_ENTITY_ID === ca.ACTIVITY_ENTITY_ID);
        step.isVisible = isVisible;
        if (step.isVisible) {
            if (Array.isArray(step.ACTIVITY_ENTITY_TITLE)) {
                if (!step.ACTIVITY_ENTITY_TITLE.length) step.titles = [{ TEXT: step.AE_TITLE, template: `<div>${step.AE_TITLE}</div>` }];
                else step.titles = step.ACTIVITY_ENTITY_TITLE.map((title) => mapTemplates(title, step));
            }
            if (Array.isArray(step.ACTIVITY_ENTITY_MESSAGE)) step.descriptions = step.ACTIVITY_ENTITY_MESSAGE.map((description) => mapTemplates(description, step, !description.SHOW_WHEN_COMPLETE, true));
            if (Array.isArray(step.ACTIVITY_ENTITY_ACTION)) step.actions = step.ACTIVITY_ENTITY_ACTION.map((action) => mapActions(action, step, !action.SHOW_WHEN_COMPLETE, true));
        }
        else {
            step.titles = [{
                template: "<div>Step Unavailable</div>",
                include: true
            }];
            step.descriptions = [{
                template: "<div>This step is not visible to you.</div>",
                include: true
            }];
            step.actions = [];
            step.cssClasses += ' step-not-visible';
            step.excludeFromCount = true;
        }

        // TODO Remove Test line
        step.enable = true; // Test enabled state without PREV_RECORD

        processStepLogic(step);
        // Set up the sub-record merging
        step.enableSubRecordMerging = true;
        step.subRecordMergeRules = [
            {
                subSourceKey: 'affiliations',
                subRecordFilter: 'this.subRecord.ACTIVITY_ENTITY_ID === this.item.ACTIVITY_ENTITY_ID',
                mergeWithParent: true,
                // If changing this, also change the history template that is added to ste descriptions
            },
            {
                subSourceKey: 'waivers',
                subRecordFilter: 'this.subRecord.LOGBOOK_AFFILIATION_ID === this.record.AFFILIATION_ID',
                parentOutputKey: 'stepWaiver',
            },
            {
                subSourceKey: 'shifts',
                subRecordFilter: 'this.subRecord.AE_AFFILIATION_ID === this.record.AFFILIATION_ID',
                mergeWithParent: true,
            },
            {
                subSourceKey: 'lbes',
                subRecordFilter: 'this.subRecord.LOGBOOK_AFFILIATION_ID === this.record.AFFILIATION_ID',
                parentOutputKey: 'stepLbe',
            },
            {
                subSourceKey: 'trainings',
                subRecordFilter: 'this.subRecord.LOGBOOK_AFFILIATION_ID === this.record.AFFILIATION_ID',
                parentOutputKey: 'stepTraining',
            }
        ];
        let adminControls = {
            template: `<div>
                <button type="button" class="coordinator-action-button" title="Edit Affiliation"
                    @click="actionStore.editAffiliation({ affID: record.AFFILIATION_ID, showInDialog: { AFF_STATUS: true, AFF_REASON: true, AFF_NOTE: true, AFF_START_DATE_TYPE: true, AFF_START_DATE: true, AFF_EXPIRATION_DATE_TYPE: true, AFF_EXPIRATION_DATE: true } })"
                ><span class="h-button-text">Edit</span></button>
            </div>`,
            cssClasses: 'coordinator-actions',
            includeWhen: [{
                criteria: {
                    rules: [{
                        field: 'CLIENT_IS_ADMIN',
                        type: 'string',
                        operator: 'equal',
                        value: 'yes',
                        criteriaRecord: 'component.ecUserProperty'
                    }],
                    condition: 'and'
                },
                resultType: 'returnCriteria'
            }]
        };
        let coordinatorControls = {
            template: `<div>
                <button type="button" class="coordinator-action-button" title="View History"
                    @click="actionStore.openComponentDialog(
                        {
                            componentId: 'itemList_affiliation_history__workflow_step_' + index,
                            contextRecordIds: { affId: record.AFFILIATION_ID },
                            dialogSettings: {title: 'Activity History'},
                            component: {
                                volId: component.volId,
                                oppId: component.oppId,
                                orgId: component.orgId,
                                lbeId: component.lbeId,
                                schId: component.schId,
                                affId: component.affId,
                                aeId: component.aeId
                            }
                        }
                    )"
                ><span class="h-button-text">View History</span></button>
            </div>`,
            cssClasses: 'coordinator-actions',
            includeWhen: [{
                criteria: {
                    rules: [{
                        field: 'CLIENT_ROLE_OPTION',
                        type: 'string',
                        operator: 'isnotempty',
                        criteriaRecord: 'component.ecUserProperty'
                    }],
                    condition: 'and'
                },
                resultType: 'returnCriteria'
            }]
        };
        let coordinatorMessages = {
            template: `<div>
                <div class="aff-info-text">{{record.affStatusText}}</div>
                <div class="aff-info-text">{{record.affReasonText}}</div>
                <div class="aff-info-text">(ID: {{record.AFFILIATION_ID}})</div>
            </div>`,
            cssClasses: 'coordinator-info',
            includeWhen: [{
                criteria: {
                    rules: [{
                        field: 'CLIENT_ROLE_OPTION',
                        type: 'string',
                        operator: 'isnotempty',
                        criteriaRecord: 'component.ecUserProperty'
                    }],
                    condition: 'and'
                },
                resultType: 'returnCriteria'
            }]
        };
        let refreshStep = {
            template: `<div>
                <button type="button" class="coordinator-action-button" title="Refresh Step"
                    @click="actionStore.refreshWorkflowStep({ record })"
                ><span class="h-button-text">Refresh</span></button>
            </div>`,
            cssClasses: 'coordinator-actions',
            includeWhen: [{
                criteria: {
                    rules: [{
                        field: 'CLIENT_ROLE_OPTION',
                        type: 'string',
                        operator: 'isnotempty',
                        criteriaRecord: 'component.ecUserProperty'
                    }],
                    condition: 'and'
                },
                resultType: 'returnCriteria'
            }]
        };
        let expirationMessage = {
            template: `<div v-if="record.AFF_EXPIRATION_DATE">
                <span class="expiration-flag"
                    v-if="moment().isSameOrAfter(moment(record.AFF_EXPIRATION_DATE, 'MM/DD/YYYY').subtract(30, 'days'))
                    && moment().isBefore(moment(record.AFF_EXPIRATION_DATE, 'MM/DD/YYYY'))">
                    Status: <span class="expiring">Expiring soon {{record.AFF_EXPIRATION_DATE}}
                    <span v-if="record.AFF_COMPLIANCE_STATUS_ID === 5"> (Renewal Started)</span>
                    </span>
                </span>
                <span class="expiration-flag"
                      v-else-if="moment().isSameOrAfter(moment(record.AFF_EXPIRATION_DATE, 'MM/DD/YYYY'))"
                      >Status: <span class="expired">Expired {{record.AFF_EXPIRATION_DATE}}</span></span>
                <span class="expiration-flag" v-else>
                    <span class="current">Current expires: {{record.AFF_EXPIRATION_DATE}}</span></span>
            </div>`,
            cssClasses: 'expiration-status'
        };
        let renewalInProgress = {
            template: `<div v-if="record.renewalExpDate && record.AFF_STATUS_ID === 3">
                            <p>Renewal {{record.affStatusText}} - Expires: {{record.renewalExpDate}}</p>
                       </div>`,
            cssClasses: 'renewal-in-progress-msg'
        };
        processExpiration(step);
        step.descriptions.push(...[expirationMessage, renewalInProgress, coordinatorMessages, coordinatorControls, adminControls, refreshStep]);
        // TODO: Add other merge rules
        return step;
    }
};

const editorSettings = {
    affiliationIdSource: {
        type: 'dropdown',
        label: 'Affiliation ID Source',
        items: [
            { text: 'From HTML Attribute "attribute-aff-id"', value: 'props' },
            { text: 'Context Affiliation', value: 'context' },
            { text: 'Find Match Using Volunteer/Activity', value: 'match' },
        ],
        fields: {
            text: 'text',
            value: 'value'
        }
    },
    relatedActivitySource: {
        type: 'dropdown',
        label: 'Matching Activity Source',
        items: [
            { text: 'From HTML Attribute "attribute-ae-id"', value: 'props' },
            { text: 'Context Activity', value: 'context' },
            { text: 'Specific Activity', value: 'specific' },
        ],
        fields: {
            text: 'text',
            value: 'value'
        }
    },
    relatedActivityId: {
        type: 'dropdown',
        label: 'Specific Related Activity',
        itemsSource: '',
        fields: {
            text: 'text',
            value: 'value'
        }
    },
    relatedVolSource: {
        type: 'dropdown',
        label: 'Matching Volunteer Source',
        items: [
            { text: 'from HTML Attribute "attribute-vol-id"', value: 'props' },
            { text: 'Context Volunteer', value: 'context' },
        ],
        fields: {
            text: 'text',
            value: 'value'
        }
    },
    itemIconType: {
        id: 'itemIconType',
        type: 'dropdown',
        items: [
            { text: 'None', value: 'none' },
            { text: 'Number', value: 'number' },
            { text: 'Avatar Image', value: 'avatar' },
            { text: 'First Name Initial', value: 'first_initial' },
            { text: 'Last Name Initial', value: 'last_initial' },
        ],
        fields: { text: 'text', value: 'value' },
        label: 'Main Icon for Item',
        helpText: 'Specify the icon for each item.',
        default: 'number'
    },
    itemIconSize: {
        id: 'itemIconSize',
        type: 'dropdown',
        items: [
            { text: 'Small', value: 'small' },
            { text: 'Medium', value: 'medium' },
            { text: 'Large', value: 'large' },
        ],
        fields: { text: 'text', value: 'value' },
        helpText: 'Specify the size of the item icon.',
        label: 'Item Icon Size',
        default: 'small',
        logic: [
            {
                record: 'self',
                prop: 'display',
                valueType: 'criteria',
                criteria: "this.controls.itemIconType.value === 'number' || this.controls.itemIconType.value === 'avatar' || this.controls.itemIconType.value === 'first_initial' || this.controls.itemIconType.value === 'last_initial'"
            }
        ],
    },
    avatarContactCardId: {
        type: 'dropdown',
        id: 'avatarContactCardId',
        itemsSource: 'componentStore.getList(true)',
        itemsFilter: 'this.item.cType === "contactCard"',
        fields: { text: 'cId', value: 'cId' },
        label: 'Avatar Contact Card ID',
        helpText: 'Choose the Contact Card to use for the Avatar Icon.',
        logic: [
            {
                record: 'self',
                criteriaRecord: 'component',
                prop: 'display',
                valueType: 'criteria',
                criteria: "this.controls.itemIconType.value === 'avatar'"
            }
        ]
    },
};

const activityStepPanelConfig = {
    cId: "activityStepPanel",
    cType: "activityStepPanel",
    cTitle: "Activity Step Panel",
    cTemplate: `<div v-if="logicParserReady" class="activity-step-panel" :class="mappedStep.cssClasses">
        <div class="record-sources">
            <button type="button" @click="showRecordSources()">
                <span class="fa-solid fa-hexagon-nodes" title="Connections"></span>
            </button>
        </div>
        <div class="item-icon">
            <span>{{stepNumber}}</span>
        </div>
        {{mappedStep.enable}} - {{mappedStep.include}} - {{mappedStep.complete}}
        <div class="item-content">
            <div v-for="(title, iindex) in mappedStep.activeTitles" :class="title.cssClasses" :key="iindex">
                <component :is="title.tmpTemplateId()" :record="mappedStep.record" class="item-title"></component>
            </div>
            <div v-for="(description, iindex) in mappedStep.activeDescriptions" :class="description.cssClasses" :key="iindex">
                <component :is="description.tmpTemplateId()" :record="mappedStep.record"></component>
            </div>
        </div>
        <div class="item-action-area action-ctrls" :class="mappedStep.actionButtonDisplay">
            <div v-for="(action, iindex) in mappedStep.activeActions"
                 class="item-action-item e-icons"
                 :class="mappedStep.actionIcon"
                 :key="action.actionId"
            >
                <control :name="action.actionId"
                         :key="action.actionId"
                         :ref="action.ref || action.id"
                         :actionParams="[action, mappedStep]"
                         data-test-id="action.dataTestId"
                         :class="action.cssClasses"
                         :disabled="action.disabled"
                         :label="action.label"
                         :style="{color:action.actionTextColor, background:action.actionBackgroundColor, borderRadius:mappedStep.actionBorderRadius}"
                         :prop-config="{
                                removeOnDestroy: true,
                                hideLabel: action.hideLabel,
                                type: 'button',
                                actionIcon: action.ACTION_ICON || action.actionIcon,
                                onclick: actionClick
                         }"
                ></control>
                <p v-if="action.message">{{action.message}}</p>
            </div>
        </div>
        <div class="item-action-area complete-indicator" v-if="mappedStep.complete">
            <span class="e-icons e-complete"></span>
            <span style="font-size:20px; font-weight: bold;">Complete</span>
        </div>
    </div>`,
    controls: [
    ]
};

let perfTimes = {
    affInitial: false,
    affResponse: false,
    aeInitial: false,
    aeResponse: false
};

const activityStepPanelCmp = {
    name: "activityStepPanel",
    editorSettings: editorSettings,
    props: {
        index: {
            excludeFromStore: true
        },
        record: {
            excludeFromStore: true
        },
        relativePrevStep: false, // comes from workflowViewer -> itemList
        relativeNextStep: false // comes from workflowViewer -> itemList
    },
    data() {
        return {
            logicParserReady: false,
            viewSourceRecordData: false,
            affSub: false,
            aeSub: false
        };
    },
    computed: {
        stepNumber() {
            return this.index + 1;
        },
        relatedShifts() {
            return [];
        },
        relatedLbes() {
            return [];
        },
        relatedWaiver() {
            return [];
        },
        relatedTraining() {
            return [];
        },
        relatedAssignment() {
            return [];
        },
        affRecord() {
            if (!perfTimes.affInitial) perfTimes.affInitial = performance.now();
            let affFields = [
                'AFFILIATION_ID',
                // 'DETAIL_RECORD_ID',
                'AFF_REASON_ID',
                'AFF_REASON',
                'AFF_STATUS_ID',
                'AFF_STATUS',
                // 'AFF_START_DATE',
                // 'AFF_END_DATE',
                'AFF_COMPLIANCE_STATUS',
                'AFF_COMPLIANCE_STATUS_ID',
                // 'AFF_COMPLIANCE_STATUS_VERIFIER',
                // 'AFF_STATUS_VERIFIER_DATE',
                // 'ACTIVITY_ENTITY_TITLE',
                // 'ACTIVITY_ENTITY_ID',
                'AFF_ACTIVITY_ENTITY',
                'AFF_ACTIVITY_ENTITY_ID',
                // 'AFF_ASSIGNMENT_WORKFLOW_STATUS',
                // 'AFF_STATUS_VERIFIER',
                // 'AFF_STATUS_DATETIME',
                // 'AFF_COMPLETE_DATE',
                'AFF_EXPIRATION_DATE',
                'AFF_VOLUNTEER',
                'AFF_EXPIRING_AFFILIATION_ID',
                'PREV_STEPS',
                'NEXT_STEPS',
                'AFF_RECORDS',
                'AFF_ASSIGNMENT_ID',
                // 'ASSIGNMENT_ID',
            ];
            let payload = {
                source: 'sds_getProfileField',
                params: {
                    recordPsp: 'aff',
                    recordId: this.affId,
                    fields: affFields,
                    params: { strictTypeResults: true }
                },
                updateFrequency: 20,
            };
            let subscription = this.affSub || this.recordStore.subscribe(payload, this.cId, false, false);
            if (!this.affSub) this.affSub = subscription;
            let subscriptionRecords = library.cloneObj(this.recordStore.getSubscription(subscription.key));
            if (library.objIsEmpty(subscriptionRecords)) return {};
            if (!perfTimes.affResponse) {
                perfTimes.affResponse = performance.now() - perfTimes.affInitial;
                // console.log(perfTimes.affResponse);
            }
            // let perf = performance.now();
            let formatActivityAffiliation = (affiliations) => {
                if (typeof affiliations !== 'object') return {};
                for (let affId in affiliations) {
                    if (affId === 'length') continue;
                    let affRecord = affiliations[affId]; // This will be undefined until the subscription returns data
                    if (!affRecord) continue;
                    if (!affRecord.ACTIVITY_ENTITY_ID && affRecord.AFF_RECORDS?.[8]) {
                        affRecord.ACTIVITY_ENTITY_ID = Number(affRecord.AFF_RECORDS[8][0]);
                    }
                    if (!affRecord.HISTORY) affRecord.HISTORY = {};
                    affRecord.HISTORY = Object.values(affRecord.HISTORY).reverse();
                    // eslint-disable-next-line no-loop-func
                    let statusOption = this.statusOptions.find((status) => status.value === affRecord.AFF_STATUS_ID);
                    if (typeof statusOption?.text !== 'undefined') affRecord.affStatusText = statusOption.text;
                    // eslint-disable-next-line no-loop-func
                    let reasonOption = this.reasonOptions.find((status) => status.value === affRecord.AFF_REASON_ID);
                    if (typeof reasonOption?.text !== 'undefined') affRecord.affReasonText = reasonOption.text;
                    if (affRecord.AFF_EXPIRING_AFFILIATION_ID) affRecord.renewalExpDate = this.recordStore.records.aff?.[+affRecord.AFF_EXPIRING_AFFILIATION_ID]?.AFF_EXPIRATION_DATE;
                }
                return affiliations;
            };
            const findRenewalAff = (affId) => {
                // Recurse until we have no new complianceRenewalAffId property on the record
                let newAffId = subscriptionRecords[affId]?.complianceRenewalAffId || affId;
                if (subscriptionRecords[newAffId]?.complianceRenewalAffId) {
                    return findRenewalAff(subscriptionRecords[newAffId].complianceRenewalAffId);
                }
                // Add compliance expiration date to renewal record
                if (subscriptionRecords[affId]?.complianceRenewalAffId) {
                    subscriptionRecords[newAffId].renewalExpDate = subscriptionRecords[affId]?.AFF_EXPIRATION_DATE;
                }
                return newAffId;
            };
            subscriptionRecords = formatActivityAffiliation(subscriptionRecords);
            // console.log(performance.now() - perf);
            return subscriptionRecords[this.affId];
        },
        activityRecord() {
            if (!perfTimes.aeInitial) perfTimes.aeInitial = performance.now();
            let activityId = this.affRecord?.ACTIVITY_ENTITY_ID;
            if (!activityId) return {};
            let activityFields = [
                'ACTIVITY_ENTITY_ACTION',
                'ACTIVITY_ENTITY_ID',
                'ACTIVITY_ENTITY_MESSAGE',
                'ACTIVITY_ENTITY_TITLE',
                // 'ACTIVITY_TYPE_ID',
                'AE_COMPLETED_AFF_STATUS',
                'AE_COMPLETED_AFF_STATUS_ID',
                'AE_COMPLETED_BY_DEFAULT',
                'AE_COMPLETED_LOGIC_FILTER_ID',
                'AE_CSSCLASSES',
                'AE_DEFAULT_AFF_COMPLIANCE_STATUS',
                'AE_DEFAULT_AFF_COMPLIANCE_STATUS_ID',
                'AE_DEFAULT_AFF_STATUS',
                'AE_DEFAULT_AFF_STATUS_ID',
                'AE_DESCRIPTION',
                'AE_ENABLED_AFF_STATUS',
                'AE_ENABLED_AFF_STATUS_ID',
                'AE_ENABLED_BY_DEFAULT',
                'AE_ENABLED_LOGIC_FILTER_ID',
                'AE_ENABLED_SET',
                'AE_ENABLED_SET_AFF_REASON_ID',
                'AE_ENABLED_SET_AFF_START_DATE',
                'AE_ENABLED_SET_AFF_STATUS_ID',
                'AE_INCLUDED_AFF_STATUS',
                'AE_INCLUDED_AFF_STATUS_ID',
                'AE_INCLUDED_BY_DEFAULT',
                'AE_INCLUDED_LOGIC_FILTER_ID',
                'AE_IS_COMPLIANCE',
                'AE_ONCE_AND_DONE',
                'AE_ONCE_AND_DONE_INCLUDE_FILTER_ID',
                'AE_TITLE'
            ];
            let payload = {
                source: 'sds_getProfileField',
                params: {
                    recordPsp: 'ae',
                    recordId: activityId,
                    fields: activityFields,
                    params: { strictTypeResults: true }
                },
                updateFrequency: 0,
            };
            let subscription = this.aeSub || this.recordStore.subscribe(payload, this.cId, false, false);
            if (!this.aeSub) this.aeSub = subscription;
            let subscriptionRecords = this.recordStore.getSubscription(subscription.key);
            subscriptionRecords = library.cloneObj(subscriptionRecords);
            let activityRecord = subscriptionRecords[activityId];
            if (activityRecord) {
                if (!perfTimes.aeResponse) {
                    perfTimes.aeResponse = performance.now() - perfTimes.aeInitial;
                    // console.log(perfTimes.aeResponse);
                }
                // Format the activity to a Workflow Step Panel
                if (!this.affRecord) return {};
                let relativeRecords = {
                    aff: [this.affRecord],
                    assignment: [], // TODO get all these connected
                    lbe: [],
                    waiver: [],
                    training: [],
                    sch: [],
                };
                activityRecord.AFFILIATION_ID = this.affId;
                activityRecord = locals.formatToUI(activityRecord, relativeRecords, this);
                // if (!activityRecord) return {};
                // Process the workflowViewer -> itemList record changes
                if (!Array.isArray(activityRecord.titles)) activityRecord.titles = [];
                activityRecord.titles.forEach((cTitle, titleIndex) => {
                    if (!cTitle.tmpTemplateId) {
                        cTitle.tmpTemplateId = () => (createComp.call(this, cTitle.template, 'title', titleIndex));
                    }
                });
                if (!Array.isArray(activityRecord.descriptions)) activityRecord.descriptions = [];
                activityRecord.descriptions.forEach((cDescription, descIndex) => {
                    if (!cDescription.tmpTemplateId) {
                        cDescription.tmpTemplateId = () => (createComp.call(this, cDescription.template, 'description', descIndex, this.uniqueId));
                    }
                });
            }
            return activityRecord;
        },
        prevActivityAff() {
            return this.affRecord.PREV_STEPS;
        },
        nextActivityAff() {
            return this.affRecord.NEXT_STEPS;
        },
        prevActivityRecord() {
            return this.prevActivityAff;
        },
        nextActivityRecord() {
            return this.nextActivityAff;
        },
        mappedStep() {
            let perf = performance.now();
            let activityItem = library.cloneObj(this.activityRecord);
            if (library.objIsEmpty(activityItem)) return {};
            activityItem.record = library.cloneObj(this.affRecord);
            let setCurrItem = (item) => {
                let record = item.record;
                let prevItem = {}; // TODO connect this
                let nextItem = {}; // TODO connect this
                let logicResult = true;

                if (item.hasOwnProperty('WORKFLOW_ID')) {
                    item.previousStepsComplete = (prevItem?.complete && prevItem?.previousStepsComplete) || !prevItem;
                }

                if (item.enableWhen && item.enableWhen.length) {
                    logicResult = library.logicParser.call(this, item.enableWhen, item, item.record, prevItem, nextItem);
                    if (typeof logicResult === 'boolean') item.enable = logicResult;
                }

                if (item.activeWhen && item.activeWhen.length) {
                    logicResult = library.logicParser.call(this, item.activeWhen, item, item.record, prevItem, nextItem);
                    if (typeof logicResult === 'boolean') item.active = logicResult;
                }

                if (item.completeWhen && item.completeWhen.length) {
                    logicResult = library.logicParser.call(this, item.completeWhen, item, item.record, prevItem, nextItem);
                    if (typeof logicResult === 'boolean') item.complete = logicResult;
                }
                // Set enable, active, and complete styles
                if (item.enable) item.cssClasses += ' item-enabled';
                if (item.active) item.cssClasses += ' item-active';
                if (item.complete) item.cssClasses += ' item-complete';
                // Parse Actions
                let currActions = library.cloneObj(item.actions);
                if (!Array.isArray(currActions)) currActions = [];
                currActions.forEach((action, index) => {
                    action.actionId = `action-item_${this.cId.replace(" ", /_/g).toLowerCase()}_${index}`;
                    if (!action.cssClasses) action.cssClasses = '';
                    let included = true;
                    let disabled = false;
                    if (item.complete && action.hideWhenComplete) included = false;
                    if (!item.complete && !item.enable && action.hideWhenDisabled) included = false;
                    if (included && action.includeWhen && action.includeWhen.length) {
                        included = library.logicParser.call(this, action.includeWhen, item.actions[index], record, prevItem, nextItem);
                    }
                    if (included && action.disableWhen && action.disableWhen.length) {
                        disabled = library.logicParser.call(this, action.disableWhen, item.actions[index], record, prevItem, nextItem);
                    }
                    if (typeof included === 'boolean') action.include = included;
                    if (typeof disabled === 'boolean') action.disabled = disabled;
                });
                let activeActions = currActions.filter((action) => action.include === true);
                // Parse Descriptions
                let currDescriptions = library.cloneObj(item.descriptions);
                if (!Array.isArray(currDescriptions)) currDescriptions = [];
                currDescriptions.forEach((description) => {
                    if (description) {
                        let included = true;
                        if (item.complete && description.hideWhenComplete) included = false;
                        if (!item.complete && !item.enable && description.hideWhenDisabled) included = false;
                        if (included && description.includeWhen && description.includeWhen.length) {
                            included = library.logicParser.call(this, description.includeWhen, description, record, prevItem, nextItem);
                        }
                        if (typeof included === 'boolean') description.include = included;
                    }
                });
                let activeDescriptions = currDescriptions.filter((description) => description.include === true);
                // Parse Titles
                let currTitles = library.cloneObj(item.titles);
                if (!Array.isArray(currTitles)) currTitles = [];
                currTitles.forEach((title) => {
                    let included = true;
                    if (item.complete && title.hideWhenComplete) included = false;
                    if (included && !item.complete && !item.enable && title.hideWhenDisabled) included = false;
                    if (included && title.includeWhen && title.includeWhen.length) {
                        included = library.logicParser.call(this, title.includeWhen, title, record, prevItem, nextItem);
                    }
                    if (typeof included === 'boolean') title.include = included;
                });
                let activeTitles = currTitles.filter((title) => title.include === true);
                let bgColor = '#c5dfef';
                // if (!item.enableEvenOddColors) {
                //     bgColor = item.itemBackgroundColor;
                // } else {
                //     bgColor = index % 2 === 0 ? item.evenItemBackgroundColor : item.oddItemBackgroundColor;
                // }
                if (item.complete && item.itemCompleteColor) bgColor = item.itemCompleteColor;
                else if (!item.enable && item.itemDisabledColor) bgColor = item.itemDisabledColor;
                else if (item.active && item.itemActiveColor) bgColor = item.itemActiveColor;
                let newItem = library.cloneObj(item);
                newItem = {
                    ...newItem,
                    record,
                    enable: item.enable,
                    complete: item.complete,
                    active: false,
                    hovered: false,
                    selected: false,
                    activeTitles,
                    activeDescriptions,
                    activeActions,
                    // itemIndex: item.itemIndex, // TODO connect this
                    backgroundColor: bgColor,
                    actionButtonDisplay: item.itemActionDisplay,
                    actionBorderRadius: item.actionBorderRadius
                };
                // if (this.config.itemIconType === 'first_initial') {
                //     newItem.iconInitials = record.VOL_FIRST_NAME.substring(0, 1);
                // }
                // else if (this.config.itemIconType === 'last_initial') {
                //     newItem.iconInitials = record.VOL_LAST_NAME.substring(0, 1);
                // }
                // Run actions after everything else has been processed
                // TODO make this configurable
                if (item.onChangeActions && !this.componentPendingSubscriptions.length) {
                    let cActions = item.onChangeActions;
                    cActions.forEach((iAction) => {
                        let actionResult = true;
                        if (!iAction.runOnce || (iAction.runOnce && (!runOnceActions[this.cId] || !runOnceActions[this.cId][index]))) {
                            if (iAction.logic) {
                                actionResult = library.logicParser.call(this, iAction.logic, item, item.record, prevItem, nextItem);
                            }
                            if (typeof iAction.executeIfLogicResult !== 'undefined' && actionResult !== iAction.executeIfLogicResult) return;
                            if (!runOnceActions[this.cId]) runOnceActions[this.cId] = {};
                            // TODO: Maybe change this to make it more unique
                            if (!runOnceActions[this.cId][index]) {
                                runOnceActions[this.cId][index] = actionResult;
                                if (Array.isArray(iAction.actions)) {
                                    actionStore.runChainedActions(iAction.actions, { ...item.record, prevItem, nextItem }, this);
                                }
                            }
                        }
                    });
                }
                return newItem;
            };
            let output = setCurrItem(activityItem);
            // console.log(performance.now() - perf);
            // average 15-20 ms per step
            return output;
            // TODO emit state of this step only
            // this.$emit('update:enabledItems', mappedItems.filter((iItem) => iItem.enable && !iItem.complete));
            // this.$emit('update:completedItems', mappedItems.filter((iItem) => iItem.complete));
        }
    },
    methods: {
        showRecordSources() {
            let _this = this;
            let dialogTemplate = {
                data() {
                    return {
                        volId: _this.volId,
                        oppId: _this.oppId,
                        orgId: _this.orgId,
                        affId: _this.affId,
                        aeId: _this.activityRecord.ID,
                        mappedStep: _this.mappedStep,
                        viewSourceRecordData: false
                    };
                },
                template: `<span class="sources-label">Record Sources</span>
                    <span>Context Volunteer: {{volId}}</span>
                    <span>Context Opportunity: {{oppId}}</span>
                    <span>Context Organization: {{orgId}}</span>
                    <span>Context Affiliation: {{affId}}</span>
                    <span>Context Activity: {{aeId}}</span>
                    <span>Source: ({{mappedStep.psp}}) {{mappedStep.uiRecordId}}</span>
                    <button type="button" @click="viewSourceRecordData = !viewSourceRecordData">View Source Record</button>
                    <pre v-if="viewSourceRecordData">
                        {{mappedStep}}
                    </pre>`
            };
            library.showDialog(dialogTemplate);
        },
        async actionClick(event, control, actionParams) {
            const [action, item] = actionParams;
            let response;
            // Perform an action
            let actionConfig = library.cloneObj(action.action);
            let prevItem = []; // TODO Connect these
            let nextItem = [];
            if (Array.isArray(actionConfig)) {
                let controlParams = {
                    name: control.name,
                    label: control.label
                };
                if (actionParams && actionParams?.[0]?.ACTIVITY_ENTITY_ACTION_ID) {
                    controlParams.ACTIVITY_ENTITY_ACTION_ID = actionParams[0].ACTIVITY_ENTITY_ACTION_ID;
                }
                let tmpRecord = {
                    ...item.record, prevItem, nextItem, controlParams
                };
                if (!tmpRecord.VOLUNTEER_ID && this.contextVolId) {
                    tmpRecord.VOLUNTEER_ID = this.contextVolId;
                }
                response = await actionStore.runChainedActions(actionConfig, tmpRecord, this);
            }
            else {
                if (actionConfig.action) {
                    let payload = library.recordSourceMapper(actionConfig.action, actionConfig.params, { ...item.record, prevItem, nextItem }, this, true);
                    if (payload) response = await actionStore[actionConfig.action](payload);
                }
            }
            return response;
        },
        async onCreate() {
            await library.prepLogicParsingToFront();
            this.logicParserReady = true;
            this.statusOptions = await configStore.attrListOptions("aff_status_2");
            this.reasonOptions = await configStore.attrListOptions("aff_reason_2");
        },
        onUpdate() {
            // called each time, when the any property from data/props were updated ( Vue "updated"  wrapper )
        },
        onPropsUpdate() {
            // called each time, when the any property from props were updated
        },
        onMappedDataUpdate() {
            // called each time, when the any mapped data of component were updated
        },
        onLoad() {
            // console.log(this);
            // setInterval(() => {
            //     console.log(this);
            // }, 10000);
            // called when the component settings were uploaded from the sDs and component ready for render
            // uStore().getUserData().then((user) => {
            //     this.user = user;
            // });
            /*
                call this.sDs.post('functionName', param1, param2) if you need to get some data from backend
                functionName can be found in common/config/sDs.inc file
            */
            // this.sDs.post('functionName', param1, param2)
        }
    },
    components: {
        'ejs-skeleton': SkeletonComponent
    }
};
// componentStore.initComponent puts the component into the component store, makes the component available to other vue components, and adds it to the list of component options used in editors
componentStore.initComponent(activityStepPanelCmp, activityStepPanelConfig);

export { activityStepPanelConfig, activityStepPanelCmp };
export default activityStepPanelCmp;
</script>

<style scoped>

.activity-step-panel {
    background: #ffffff;
    padding: 10px;
    font-family: 'Open Sans';
    display: flex;
    font-size: 18px;
}
.record-sources {
    position: absolute;
    right: 4px;
    top: 3px;
}
.record-sources > button {
    font-size: 18px;
    height: 30px;
    width: 32px;
    text-align: center;
    color: rgb(12 27 132 / 80%);
    background: rgba(255, 255, 255, 0.25);
    border: 0 none;
    border-radius: 50%;
}

/* styles from itemList */
.item-icon {
    border-radius: 50%;
    font-weight: bold;
    line-height: 33px;
    text-align: center;
    grid-area: icon;
}
.item-icon {
    width: 32px;
    height: 32px;
    padding-top: 0;
    font-size: 18px;
    background: #e3f1fc;
}
.item-title {
    z-index: 3;
}
.item-content {
    flex-grow: 9;
    grid-area: content;
    padding: 0 10px 0 10px;
}
.item-content p {
    margin: 6px 0;
    font-size: 0.85rem;
}
.action-ctrls {
    grid-area: action;
}
.complete-indicator {
    grid-area: complete
}
.item-action-area {
    align-items: center;
}
.item-action-item {
    text-align: right;
    margin: 5px 0 5px 10px;
}
.item-action-item button {
    display: flex;
}
.item-complete {
    font-size: 16px;
    background: #c8e5f8;
}
.item-disabled {
    position: relative;
    font-size: 14px;
    background: #ddd;
}
.item-disabled.list-item:nth-child(even) {
    background: #ddd;
}
.item-disabled::after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    background: white;
    cursor: not-allowed;
    opacity: 0.25;
}
.action-btn-inline {
    display: flex;
    align-items: flex-end;
}
/*.action-icon.e-icons {
    font-size: 1.25rem;
}*/
:deep(.e-icons.e-complete:before) {
    content: '\e192' !important;
}
/* styles from workflowViewer */
:deep(.expiration-status) {
    font-size: 90%;
    margin-top: 15px;
}
:deep(.renewal-in-progress-msg) {
    font-size: 1rem;
    color: #494949
}
:deep(.expiration-flag) {
    margin-right: 10px;
    font-size: 16px;
}
:deep(.current) { color: #16a34a }
:deep(.expiring) { color: #FB8432 }
:deep(.expired) { color: #dc2626 }
:deep(.activity-expiration) {
    display: flex;
    gap: 1rem;
    margin: 1rem 0;
    padding: 1rem;
    border-radius: 0.5rem;
    background: #fef4eb;
    width: fit-content
}
@media (max-width: 620px) {
    :deep(.activity-expiration) {
        flex-direction: column;
    }
    :deep(.btn-renewal.coordinator-action-button) {
        margin: 0 5px;
    }
}
:deep(.activity-expiration) {
    display: flex;
    gap: 1rem;
    margin: 1rem 0;
    padding: 1rem;
    border-radius: 0.5rem;
    background: #fef4eb;
    width: fit-content
}
:deep(.activity-expiration > .expiration-text) {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    color: #060606;
}
:deep(.activity-expiration > i) {
    font-size: 2rem;
    color: #ff3e33;
    animation: vibrate 30s infinite ease-in-out;
}
:deep(.activity-expiration > button) {
    align-self: start;
    padding: 0.75rem 1.25rem;
    font-size: 1.25rem;
    background: rgb(22, 92, 148);
    border-radius: 0.5rem;
    color: #fff;
    text-decoration: none
}
:deep(.activity-expiration > button:hover) {
    background: #2364f1;
}
:deep(.aff-info-text) {
    display: inline-block;
    padding-right: 8px;
}
:deep(.coordinator-actions), :deep(.coordinator-info) {
    display: inline-block;
    margin-top: 15px;
}
:deep(.coordinator-info) {
    border-right: 1px solid #bbbbbb;
}
:deep(.coordinator-action-button) {
    border: 0 none;
    transition: background .1s ease-in;
    background: rgba(255, 255, 255, .20);
    border-radius: 15px;
    color: #2b2b86;
    padding: 5px 15px;
    margin: 5px;
    font-size: 14px;
    display: inline-block;
    text-decoration: underline;
}
:deep(.coordinator-action-button:hover) {
    background: rgba(0, 0, 0, .08);
    transition: all .1s ease-in-out;
}
:deep(.history-button .e-icons) {
    margin-right: 3px;
    position: relative;
    top: 2px;
    font-size: 13px;
}
.workflow-header {
    display: flex;
    padding: 5px;
    border-bottom: 1px solid #b0b0b0;
    color: #383c50;
}
.workflow-loader p {
    display: inline-block;
    line-height: 24px;
    font-size: 16px;
    margin: 0 0 0 15px;
    vertical-align: top;
}
.no-workflows-message {
    font-size: 16px;
}
.workflow-status {
    text-align: right;
    flex-grow: 9;
    font-size: 16px;
    font-weight: bold;
}
.assignment-id {
    font-size: 14px;
}
:deep(.step-not-visible) {
    display: none;
}
@keyframes vibrate {
    0%, 96.9% { transform: rotate(0deg) translateX(0); }
    97.0% { transform: rotate(-3deg) translateX(-2px); }
    97.1% { transform: rotate(3deg)  translateX(2px); }
    97.2% { transform: rotate(-3deg) translateX(-2px); }
    97.3% { transform: rotate(3deg)  translateX(2px); }
    97.4% { transform: rotate(-2.5deg) translateX(-1.8px); }
    97.5% { transform: rotate(2.5deg)  translateX(1.8px); }
    97.6% { transform: rotate(-2.5deg) translateX(-1.8px); }
    97.7% { transform: rotate(2.5deg)  translateX(1.8px); }
    97.8% { transform: rotate(-2deg) translateX(-1.5px); }
    97.9% { transform: rotate(2deg)  translateX(1.5px); }
    98.0% { transform: rotate(-2deg) translateX(-1.5px); }
    98.1% { transform: rotate(2deg)  translateX(1.5px); }
    98.2% { transform: rotate(-1.5deg) translateX(-1px); }
    98.3% { transform: rotate(1.5deg)  translateX(1px); }
    98.4% { transform: rotate(-1.5deg) translateX(-1px); }
    98.5% { transform: rotate(1.5deg)  translateX(1px); }
    98.6% { transform: rotate(-1deg) translateX(-0.8px); }
    98.7% { transform: rotate(1deg)  translateX(0.8px); }
    98.8% { transform: rotate(-0.5deg) translateX(-0.5px); }
    98.9% { transform: rotate(0.5deg)  translateX(0.5px); }
    99%, 100% { transform: rotate(0deg) translateX(0); }
}
</style>
